import { toggleItemLoading } from '../render/item_loading'
import slugify from '../utils/slugify'

const LOADING_RESET_DELAY = 1500

async function downloadUrl(url: string, name: string, element: Element) {
    const cleanName = slugify(name)

    try {
        const response = await fetch(url)
        const blob = await response.blob()
        const objectUrl = URL.createObjectURL(blob)
        triggerDownload(objectUrl, cleanName, element)
        URL.revokeObjectURL(objectUrl)
    } catch {
        triggerDownload(url, cleanName, element)
    }
}

function triggerDownload(href: string, name: string, element: Element) {
    const anchor = document.createElement('a')
    anchor.href = href
    anchor.download = name
    anchor.style.display = 'none'
    document.body.appendChild(anchor)
    anchor.click()
    document.body.removeChild(anchor)

    setTimeout(() => toggleItemLoading(element, false), LOADING_RESET_DELAY)
}

export { downloadUrl }
